import type { MetaInfo } from 'vue-meta';

export const getMetaInfo = (page: any, isNoIndex: boolean = false, type: string | boolean = false): MetaInfo => {
  if (!page) {
    return null;
  }

  const seoTags: MetaInfo = {
    meta: [],
  };

  const defaultCategoryDescription = (page: any, type: string | boolean) => {
    switch (type) {
      case 'category':
        return `${page?.title || page?.name} | esplora la gamma di prodotti e servizi per professionisti, aziende e pubblica amministrazione del Sole 24 Ore Professionale`;
      case 'product':
        return `${page?.title || page?.name} | scopri tutte le funzionalità e i vantaggi del servizio che Il Sole 24 ORE Professionale ha sviluppato per i professionisti del settore.`;
      case 'page':
        return `${page?.title || page?.name} | per maggiori informazioni visita la pagina dedicata sul sito del Sole 24 Ore Professionale.`;
      default:
        return 'Per maggiori informazioni visita la pagina dedicata sul sito del Sole 24 Ore Professionale.';
    }
  }


  if (page?.meta_title || page?.title || page?.name) {
    seoTags.titleTemplate = page?.meta_title || `${page?.title} | Il Sole 24 Ore Professionale` || `${page?.name} | Il Sole 24 Ore Professionale`;
  }
  if (page?.meta_description) {
    seoTags.meta.push({
      hid: 'description',
      name: 'description',
      content: page.meta_description,
    });
  } else {
    seoTags.meta.push({
      hid: 'description',
      name: 'description',
      content: defaultCategoryDescription(page, type),
    });
  }

  if (page?.meta_keyword || page?.meta_keywords) {
    seoTags.meta.push({
      hid: 'keywords',
      name: 'keywords',
      content: page?.meta_keyword || page?.meta_keywords,
    });
  }
  if (isNoIndex) {
    seoTags.meta.push({
      name: 'robots',
      content: 'noindex, nofollow',
    });
  }

  return seoTags;
};
